module.exports = __webpack_public_path__ + "static/car-pc/img/array-up.14ee2083.svg";